var exports = {
  "tm": "EmailHandoffForm__xY4y7U",
  "zY": "EmailHandoffDialog__W-C_qd",
  "g2": "EmailHandoffDialogHeader__qeJSiX",
  "BY": "EmailHandoffDialogClose__i1Np5J",
  "pn": "EmailHandoffDialogBody__-kwglR",
};

module.exports = exports;
